const config = {
	apiDomain: 'https://demo.engagevi.local',
	portalDomain: 'http://localhost:3006',
	userTimeOutInMinutes : 20
};

module.exports = config;
